// @flow

// Vendors
import axios from 'axios';

// Constants
import { WL_API_URL } from '../config';

const CancelToken = axios.CancelToken;
let getProjectsCancel;

export const request = async (options = {}) => {
  try {
    const response = await axios({
      baseURL: WL_API_URL,
      timeout: 10000,
      ...options
    });

    if (response.status === 200) return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchProjects = params => {
  if (getProjectsCancel)
    getProjectsCancel('Project fetch canceled by the user.');

  return request({
    url: 'projects',
    method: 'get',
    params,
    cancelToken: new CancelToken(cancel => (getProjectsCancel = cancel))
  });
};

export const fetchMarkets = () =>
  request({
    url: 'markets',
    method: 'get'
  });

export const fetchIndustrialSectors = () =>
  request({
    url: 'industrial-sectors',
    method: 'get'
  });

export const fetchSmartBidBids = () =>
  request({
    url: 'smartbid-bids',
    method: 'get'
  });

export const getOpenAssetEmployees = () =>
  request({
    url: 'open-asset/employees',
    method: 'get'
  });

export const getOpenAssetEmployee = id =>
  request({
    url: `open-asset/employees/${id}`,
    method: 'get'
  });

export const translateRequest = words =>
  request({
    url: 'translate',
    method: 'post',
    data: {
      words
    }
  });

export const searchRequest = data =>
  request({
    url: 'search',
    method: 'post',
    data
  });

export const deleteTransientsRequest = () =>
  request({
    url: 'delete-transients'
  });
